import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FlexContainer } from '@components/common'
import Table from '@components/common/Table'
import { Button, Dropdown } from '@components/common/form'
import { Tab } from '@res/styledComponents/index'
import { colors } from '@constants'
import TrashPng from '@res/images/trash-icon.png'

const MenuItemUpdates = (props) => {
  const {
    chefNetworkCreatedNewItem,
    chefNetworkCompletedItemUpdate,
    chefNetworkDeletedCreateRequest,
    chefNetworkDeletedUpdateRequest,
    loadNewMenuItems,
    loadMenuItemUpdates,
    headquarters,
    headquarterId,
    onChangeHQ,
  } = props
  const [activeTab, setActiveTab] = useState('itemEdits')
  const [menuItemUpdates, setMenuItemUpdates] = useState([])
  const [newMenuItems, setNewMenuItems] = useState([])

  useEffect(() => {
    onLoadNewMenuItems()
    onLoadMenuItemUpdates()
  }, [headquarterId])

  const onLoadMenuItemUpdates = async () => {
    const req = {
      headquarter_id: headquarterId,
    }
    const menuItems = await loadMenuItemUpdates(req)
    if (menuItems) {
      setMenuItemUpdates(menuItems)
    } else {
      setMenuItemUpdates([])
    }
  }

  const onLoadNewMenuItems = async () => {
    const req = {
      headquarter_id: headquarterId,
    }
    const menuItems = await loadNewMenuItems(req)
    if (menuItems) {
      setNewMenuItems(menuItems)
    } else {
      setNewMenuItems([])
    }
  }

  const onMarkUpdated = async (item) => {
    const req = {
      id: item.id,
      changes_completed: true,
      headquarter_id: headquarterId,
    }
    const menuItems = await chefNetworkCompletedItemUpdate(req)
    if (menuItems) {
      setMenuItemUpdates(menuItems)
    } else {
      setMenuItemUpdates([])
    }
  }

  const onMarkCreated = async (item) => {
    const req = {
      id: item.id,
      item_created: true,
      headquarter_id: headquarterId,
    }
    const menuItems = await chefNetworkCreatedNewItem(req)
    if (menuItems) {
      setNewMenuItems(menuItems)
    } else {
      setNewMenuItems([])
    }
  }

  const onDeleteUpdateRequest = async (item) => {
    const req = {
      id: item.id,
    }
    const menuItems = await chefNetworkDeletedUpdateRequest(req)
    if (menuItems) {
      setMenuItemUpdates(menuItems)
    } else {
      setMenuItemUpdates([])
    }
  }

  const onDeleteCreateRequest = async (item) => {
    const req = {
      id: item.id,
    }
    const menuItems = await chefNetworkDeletedCreateRequest(req)
    if (menuItems) {
      setNewMenuItems(menuItems)
    } else {
      setNewMenuItems([])
    }
  }

  const renderItemEdits = () => {
    return (
      <Table>
        <tr>
          <th>Edit Request Date</th>
          <th>Chef Name</th>
          <th>Chef Email</th>
          <th>Chef Phone</th>
          <th>Item Name</th>
          <th>Requested Edit</th>
          <th>CN Made Changes</th>
          <th>Delete Item</th>
        </tr>
        {menuItemUpdates.map((item, i) => (
          <tr key={`${item.menuItemId}-${i}`}>
            {' '}
            {/* Prevent rendering issues if there are multiple reqs for the same item */}
            <td>
              <p>{item.editDate}</p>
            </td>
            <td>
              <p>{item.chef.name}</p>
            </td>
            <td>
              <p>{item.chef.email}</p>
            </td>
            <td>
              <p>{item.chef.phone}</p>
            </td>
            <td>
              <p>{item.menuItemName}</p>
            </td>
            <td>
              <p>
                {item.requestType === 'remove' && (
                  <span style={{ color: colors.violet, fontFamily: 'bold' }}>
                    DELETE ITEM:{' '}
                  </span>
                )}
                {item.message}
              </p>
            </td>
            <td>
              {item.changesCompleted ? (
                <div className="flex flex-col items-center justify-center">
                  <p className="mb-2">Yes</p>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center">
                  <Button
                    label="Changes Completed"
                    width="min-content"
                    padding="5px 10px"
                    className="mb-2"
                    onClick={() => onMarkUpdated(item)}
                  />
                </div>
              )}
            </td>
            <td>
              <div className="flex flex-col items-center justify-center">
                {item.changesCompleted && (
                  <img
                    src={TrashPng}
                    alt="Delete"
                    width="15"
                    height="15"
                    style={{ cursor: 'pointer' }}
                    onClick={() => onDeleteUpdateRequest(item)}
                  />
                )}
              </div>
            </td>
          </tr>
        ))}
      </Table>
    )
  }
  //Admin changes
  const renderNewItems = () => {
    return (
      <Table>
        <tr>
          <th>Date</th>
          <th>Chef Name</th>
          <th>Chef Email</th>
          <th>Chef Phone</th>
          <th>Item Name</th>
          <th>Description</th>
          <th>Chef Price</th>
          <th>Ingredients</th>
          <th>Dietary Restrictions</th>
          <th>Item created</th>
          <th>Delete Item</th>
        </tr>
        {newMenuItems.map((item, i) => (
          <tr key={`${item.id}-${i}`}>
            {' '}
            {/* Prevent rendering issues if there are multiple reqs for the same item */}
            <td>
              <p>{item.requestDate}</p>
            </td>
            <td>
              <p>{item.chef.name}</p>
            </td>
            <td>
              <p>{item.chef.email}</p>
            </td>
            <td>
              <p>{item.chef.phone}</p>
            </td>
            <td>
              <p>{item.menuItemName}</p>
            </td>
            <td>
              <p>{item.description}</p>
            </td>
            <td>
              <p>${item.chefPrice}</p>
            </td>
            <td>
              <p>{item.ingredients}</p>
            </td>
            <td>
              <p>{item.dietaryPreferences}</p>
            </td>
            <td>
              {item.itemCreated ? (
                <div className="flex flex-col items-center justify-center">
                  <p className="mb-2">Yes</p>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center">
                  <Button
                    label="Mark Created"
                    width="auto"
                    padding="5px 10px"
                    className="mb-2"
                    onClick={() => onMarkCreated(item)}
                  />
                </div>
              )}
            </td>
            <td>
              <div className="flex flex-col items-center justify-center">
                {item.itemCreated && (
                  <img
                    src={TrashPng}
                    alt="Delete"
                    width="15"
                    height="15"
                    style={{ cursor: 'pointer' }}
                    onClick={() => onDeleteCreateRequest(item)}
                  />
                )}
              </div>
            </td>
          </tr>
        ))}
      </Table>
    )
  }

  return (
    <div>
      {activeTab !== 'reports' && (
        <FlexContainer padding="0 0 20px 0" alignItems="flex-end">
          <Dropdown
            width="200px"
            marginBottom="0"
            label="Headquarter"
            value={headquarterId}
            onChange={(e) => onChangeHQ(Number(e.target.value))}
          >
            {headquarters.map((hq) => (
              <option key={hq.id} value={hq.id}>
                {hq.name}
              </option>
            ))}
          </Dropdown>
          <div style={{ height: '100%', width: '20px' }} />
          <Tab
            fontSize="15px"
            onClick={() => setActiveTab('itemEdits')}
            isActive={activeTab === 'itemEdits'}
          >
            Menu Item Edits
          </Tab>
          <Tab
            fontSize="15px"
            onClick={() => setActiveTab('newItem')}
            isActive={activeTab === 'newItem'}
          >
            New Menu Items
          </Tab>
        </FlexContainer>
      )}
      {activeTab === 'itemEdits' ? renderItemEdits() : renderNewItems()}
    </div>
  )
}

MenuItemUpdates.propTypes = {
  headquarters: PropTypes.array,
  headquarterId: PropTypes.number,

  chefNetworkCreatedNewItem: PropTypes.func,
  chefNetworkCompletedItemUpdate: PropTypes.func,
  chefNetworkDeletedCreateRequest: PropTypes.func,
  chefNetworkDeletedUpdateRequest: PropTypes.func,
  loadMenuItemUpdates: PropTypes.func,
  loadNewMenuItems: PropTypes.func,
  onChangeHQ: PropTypes.func,
}

export default MenuItemUpdates
